/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import { useEffect, useMemo, useState } from 'react';
import { useImmer } from 'use-immer';
import { useNavigate } from 'react-router-dom';
import Stepper from 'react-stepper-primitive';
import { Range } from 'react-range';
import { toast } from 'react-toastify';
import Select from 'react-select';

import Spinner from 'components/spinner';
import Layout from 'containers/layout';
import { getResolution } from 'utils/data';
import { useConcepts } from 'services/react-query/queries';
import { useStore } from '../store/index';

import ImageDisplay from './ImageDisplay';


const ACCEPT_RESOLUTION = [
  64, 128, 196, 256, 320, 384, 448, 512, 576, 640, 704, 768, 832, 896, 960, 1024, 1088, 1152, 1216,
  1280, 1344, 1408, 1472, 1536, 1600, 1664, 1728, 1792, 1856, 1920, 1984, 2048,
];

enum AI {
  DIFFCLIP = 'diffclip',
  VQGANCLIP = 'vqganclip',
  DALLEMEGA = 'dallemega',
  RHEA = 'rhea',
  MNEMOSYNE = 'mnemosyne',
}

function getAvailableMaxResolution(value: number) {
  let maxValue = value;
  for (let i = 0; i < ACCEPT_RESOLUTION.length; i += 1) {
    const currentValue = ACCEPT_RESOLUTION[i];
    if (value * currentValue < 327680) {
      maxValue = currentValue;
    } else {
      break;
    }
  }
  return maxValue;
}

function getConceptOptionsByAi(concepts: any, ai: string) {
    console.log("getConceptOptionsByAi()");
    console.log(concepts);
    
  return (concepts || [])
      .filter((concept) => concept.aircore === ai)
    ?.map((concept) => {
      return {
        value: {
          concepttype: concept.concepttype,
          concept: concept.jobid,
        },
        label: concept.name,
      };
    });
}

const DEFAULT_AI = {
  tier: 'free',
  text: '',
  aspectRatio: '1:1',
  resolution: '256',
  diffusionQuality: 'low',
  creditsRequired: 0,
  iterations: [200],
  width: 256,
  height: 256,
  superRes: false,
  multiple: 1,
  lowResDetail: 'Standard (256x256)',
  highResDetail: 'High (1024x1024)',
};

const DEFAULT_MNEMOSYNE = {
  text: '',
  aspectRatio: '1:1',
  tier: 'free',
  superRes: false,
  multiple: 1,
  resolution: '1024',
  selection: 'default',
  width: 1024,
  height: 1024,
  customImageResolution: {
    width: 1024,
    height: 1024,
  },
  seed: 0,
  ai: AI.MNEMOSYNE,
  diffusionQuality: 'low',
  creditsRequired: 0,
  iterations: [200],
  concept: { value: undefined, label: 'no custom concept' },
};

const CreateArt = () => {
  const cognitoid = useStore((state) => state.cognitoid);
  const balance = useStore((state) => state.balance);
  const getBalance = useStore((state) => state.getBalance);
  const createArt = useStore((state) => state.createArt);
  const navigate = useNavigate();
  const [isSubmitting, setSubmitting] = useState(false);

  const [state, updateState] = useImmer(DEFAULT_MNEMOSYNE);

  const { data: concepts } = useConcepts(cognitoid, {
    select(data) {
      return data?.filter((item) => item.status === 'finished');
    },
  });

 const [artworkImageUrl, setArtworkImageUrl] = useState(null);
    
    
  useEffect(() => {
    const calculateCredits = () => {
      const { multiple, tier, ai, diffusionQuality, resolution, iterations, superRes } = state;
      let currentTier = tier;
      let requiredCredit = 0;

      if (multiple > 1) {
        currentTier = 'premium';
      }

      switch (ai) {
        case AI.DIFFCLIP: {
          if (currentTier === 'premium') {
            requiredCredit = 5;
          }

          if (diffusionQuality === 'medium') {
            requiredCredit = 10;
          } else if (diffusionQuality === 'high') {
            requiredCredit = 25;
          } else if (diffusionQuality === 'max') {
            requiredCredit = 50;
          }

          if (resolution === '512') {
            if (requiredCredit === 0) {
              requiredCredit = 5;
            }
            requiredCredit *= 2;
          }
          break;
        }
        case AI.VQGANCLIP: {
          if (currentTier === 'premium') {
            requiredCredit = 2;
          }
          if (resolution === '512') {
            requiredCredit = 10;
          }

          if (iterations[0] > 200) {
            if (requiredCredit === 0) {
              requiredCredit = 2;
            }
            requiredCredit *= iterations[0] / 200;
          }
          break;
        }
        default: {
          if (currentTier === 'premium') {
            requiredCredit = 5;
          }
          break;
        }
      }

      if (superRes) {
        if (requiredCredit === 0) {
          // only super res is a special case and would require 4
          requiredCredit = 10;
        } else {
          requiredCredit += 8;
        }
      }

      if (requiredCredit > 0) {
        currentTier = 'premium';
      }

      updateState((draft) => {
        draft.creditsRequired = requiredCredit * multiple;
        draft.tier = currentTier;
      });
    };

    calculateCredits();
  }, [
    state.multiple,
    state.tier,
    state.ai,
    state.diffusionQuality,
    state.resolution,
    state.iterations,
    state.superRes,
  ]);

  const handleTextChange = (e) => {
    updateState((draft) => {
      draft.text = e.target.value;
    });
  };

  const onChangeStepper = (val) => {
    updateState((draft) => {
      draft.multiple = val;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newConfig: any = {
      ...state,
    };

    switch (name) {
      case 'resolution': {
        newConfig.resolution = value;
        break;
      }
      case 'aspectratio': {
        newConfig.aspectRatio = value;
        break;
      }
      case 'tier': {
        newConfig.tier = value;
        // Reset setting to free tier if tier was selected
        if (newConfig.tier === 'free') {
          newConfig.diffusionQuality = 'low';
          newConfig.multiple = 1;
          newConfig.superRes = false;
          if (newConfig.iterations[0] > 200) {
            newConfig.iterations[0] = 200;
          }
          if (newConfig.ai !== 'mnemosyne') {
            newConfig.resolution = '256';
          }
        }
        break;
      }
      case 'ai': {
        newConfig.concept = undefined;
        if (newConfig.ai === AI.MNEMOSYNE) {
          newConfig = { ...DEFAULT_MNEMOSYNE };
        } else if (newConfig.ai === AI.DIFFCLIP) {
          newConfig = {
            ...DEFAULT_AI,
            resolution: '256',
          };
        } else {
          newConfig = {
            ...DEFAULT_AI,
            resolution: '512',
          };
        }
        newConfig.ai = value;
        break;
      }
      case 'diffusionquality': {
        newConfig.diffusionQuality = value;
        break;
      }
      default: {
        break;
      }
    }

    let width;
    let height;
    switch (newConfig.aspectRatio) {
      case '1:1': {
        if (newConfig.resolution === '256') {
          width = 256;
          height = 256;
        } else if (newConfig.resolution === '512') {
          width = 512;
          height = 512;
        } else if (newConfig.resolution === '768') {
          width = 768;
          height = 768;
        } else if (newConfig.resolution === '1024') {
          width = 1024;
          height = 1024;
        }
        break;
      }
      case '16:9': {
        if (newConfig.resolution === '256') {
          width = 342;
          height = 192;
        } else if (newConfig.resolution === '512') {
          width = 684;
          height = 384;
        } else if (newConfig.resolution === '768') {
          width = 768;
          height = 768;
        } else if (newConfig.resolution === '1024') {
          width = 1024;
          height = 1024;
        }
        break;
      }
      default: {
        if (newConfig.resolution === '256') {
          width = 192;
          height = 342;
        } else if (newConfig.resolution === '512') {
          width = 384;
          height = 684;
        } else if (newConfig.resolution === '768') {
          width = 768;
          height = 768;
        } else if (newConfig.resolution === '1024') {
          width = 1024;
          height = 1024;
        }
        break;
      }
    }

    if (newConfig.resolution === 'custom' && newConfig.ai === AI.MNEMOSYNE) {
      width = state.customImageResolution.width;
      height = state.customImageResolution.height;
    }
    newConfig.width = width;
    newConfig.height = height;

    updateState(newConfig);
  };

  const handleSlider = (values) => {
    updateState((draft) => {
      draft.iterations = values;
    });
  };

  const handleBuyCredits = () => {
    navigate('/credits');
  };

  const handleBlend = async () => {
    try {
      setSubmitting(true);
      const data = {
        ...state,
        concept: state.concept?.value,
        iterations: state.iterations[0],
      };

      if (data.resolution === 'custom') {
        data.width = state.customImageResolution.width;
        data.height = state.customImageResolution.height;
      }

      const result = await createArt(data);

      const artworkImageUrl = `https://s3.amazonaws.com/ai.protogenes/art/${result.jobid}.jpg`;
      setArtworkImageUrl(artworkImageUrl);

      getBalance();
      // navigate('/queue');
    } catch (err) {
      toast.error(err.message, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setSubmitting(false);
    }    
  };

  const onChangeSuperRes = (e) => {
    updateState((draft) => {
      draft.superRes = e.target.checked;
    });
  };

  const onCustomResolutionChange = (e) => {
    const value = parseInt(e.target.value, 10);
    const targetName = e.target.name;

    updateState((draft) => {
      if (targetName === 'resolution_width') {
        draft.customImageResolution.width = value;
      } else {
        draft.customImageResolution.height = value;
      }
    });
  };

  const isAIRhea = state.ai === AI.RHEA;
  const isAIMnemosyne = state.ai === AI.MNEMOSYNE;
  const isAIDallemega = state.ai === AI.DALLEMEGA;
  const isAIDiffclip = state.ai === AI.DIFFCLIP;
  const isAIVqganclip = state.ai === AI.VQGANCLIP;

  const renderImageResolutionOptions = () => {
    if (!isAIRhea && !isAIDallemega) {
      if (isAIMnemosyne) {
        return (
          <div>
            <div>
              <h3 className="mb-6 text-2xl font-semibold">Image Resolution:</h3>
              <ul className="flex flex-col gap-y-5">
                <li className="flex items-center">
                  <input
                    type="radio"
                    value="1024"
                    name="resolution"
                    id="resolution_standard"
                    checked={state.resolution === '1024'}
                    onChange={() => {
                      updateState((draft) => {
                        draft.resolution = '1024';
                      });
                    }}
                  />
                  <label
                    className="cursor-pointer ml-2 text-lg font-medium"
                    htmlFor="resolution_standard"
                  >
                    Standard (1024x1024)
                  </label>
                </li>
              </ul>
            </div>
          </div>
        );
      }

      return (
        <div>
          <h3 className="mb-6 text-2xl font-semibold">Image Resolution:</h3>
          <ul className="flex flex-col gap-y-5">
            <li className="flex items-center">
              <input
                type="radio"
                value="256"
                name="resolution"
                id="resolution_256"
                checked={state.resolution === '256'}
                onChange={handleChange}
              />
              <label className="cursor-pointer ml-2 text-lg font-medium" htmlFor="resolution_256">
                {getResolution({
                  aspectRatio: state.aspectRatio,
                  width: state.width,
                  height: state.height,
                  superres: state.superRes.toString(),
                  resolution: '256',
                })}
              </label>
            </li>
            <li className="flex items-center">
              <input
                type="radio"
                value="512"
                name="resolution"
                id="resolution_512"
                checked={state.resolution === '512'}
                onChange={handleChange}
              />
              <label className="cursor-pointer ml-2 text-lg font-medium" htmlFor="resolution_512">
                {getResolution({
                  aspectRatio: state.aspectRatio,
                  width: state.width,
                  height: state.height,
                  superres: state.superRes.toString(),
                  resolution: '512',
                })}
              </label>
            </li>
            <li className="flex items-center">
              <input
                type="checkbox"
                checked={state.superRes}
                onChange={onChangeSuperRes}
                disabled={isSubmitting}
                id="superres"
              />
              <label className="cursor-pointer ml-2 text-lg font-medium" htmlFor="superres">
                Super (4x)
              </label>
            </li>
          </ul>
        </div>
      );
    }

    return null;
  };

  return (
    <Layout>
      <div className="absolute h-[28rem] w-full bg-header bg-cover bg-no-repeat md:mt-40 md:bg-headerBg md:bg-contain md:bg-right md:h-[25rem]" />
      <div className="container relative z-50">
        <section className="px-4 pb-14 pt-40 md:h-[35rem] md:px-10 md:pb-20 md:pt-60">
          <div className="text-center md:w-1/2 md:text-left">
            <h1 className="mb-5 text-4xl font-bold">Let’s blend some art</h1>
            <p>Ask the AI anything:</p>
            <div className="mt-6 px-8 md:px-0">
              <input
                onChange={handleTextChange}
                placeholder="i.e. Dog walking on Mars"
                className="w-full rounded-lg bg-silver py-4 px-6 text-dark placeholder:text-shuttleGray"
              />
            </div>
          </div>
        </section>
        <section className="px-8 pt-10 pb-16">
          <div className="grid gap-y-14 md:grid-cols-2 lg:grid-cols-3">

            <div>
              <h3 className="mb-6 text-2xl font-semibold">Blend:</h3>
              <ul className="flex flex-col gap-y-5">
                {[{ ai: 'mnemosyne', title: 'Mnemosyne', beta: false }].map((config) => (
                  <div key={config.ai}>
                    <li className="flex items-center">
                      <input
                        type="radio"
                        value={config.ai}
                        name="ai"
                        id={`ai_${config.ai}`}
                        checked={state.ai === config.ai}
                        onChange={handleChange}
                      />
                      <label
                        className="cursor-pointer ml-2 text-lg font-medium"
                        htmlFor={`ai_${config.ai}`}
                      >
                        {config.title}
                        {config.beta && <sup>BETA</sup>}
                      </label>
                    </li>
                    {state.ai === config.ai &&
                      getConceptOptionsByAi(concepts, config.ai).length > 0 && (
                        <div className="ml-5 mt-5">
                          <div className="flex flex-col gap-2 cursor-pointer ml-2 text-lg font-medium">
                            <Select
                              className="w-60"
                              styles={{
                                option: (styles, { isSelected }) => {
                                  return {
                                    ...styles,
                                    color: isSelected ? 'white' : 'black',
                                    ':active': {
                                      backgroundColor: 'blue',
                                      color: 'white',
                                    },
                                  };
                                },
                              }}
                              isSearchable
                              options={[
                                { value: undefined, label: 'no custom concept' },
                                ...getConceptOptionsByAi(concepts, config.ai),
                              ]}
                              value={state.concept}
                              onChange={(option) => {
                                updateState((draft) => {
                                  draft.concept = option;
                                });
                              }}
                            />
                          </div>
                        </div>
                      )}
                  </div>
                ))}
              </ul>
            </div>

            {renderImageResolutionOptions()}

            {isAIVqganclip && (
              <div>
                <h3 className="mb-6 text-2xl font-semibold">Canvas Size:</h3>
                <ul className="flex flex-col gap-y-5">
                  <li className="flex items-center">
                    <input
                      type="radio"
                      value="1:1"
                      name="aspectratio"
                      id="aspectratio_1_1"
                      checked={state.aspectRatio === '1:1'}
                      onChange={handleChange}
                    />
                    <label
                      className="cursor-pointer ml-2 text-lg font-medium"
                      htmlFor="aspectratio_1_1"
                    >
                      Square (1:1)
                    </label>
                  </li>
                  <li className="flex items-center">
                    <input
                      type="radio"
                      value="16:9"
                      name="aspectratio"
                      id="aspectratio_16_9"
                      checked={state.aspectRatio === '16:9'}
                      onChange={handleChange}
                    />
                    <label
                      className="cursor-pointer ml-2 text-lg font-medium"
                      htmlFor="aspectratio_16_9"
                    >
                      Landscape (16:9)
                    </label>
                  </li>
                  <li className="flex items-center">
                    <input
                      type="radio"
                      value="9:16"
                      name="aspectratio"
                      id="aspectratio_9_16"
                      checked={state.aspectRatio === '9:16'}
                      onChange={handleChange}
                    />
                    <label
                      className="cursor-pointer ml-2 text-lg font-medium"
                      htmlFor="aspectratio_9_16"
                    >
                      Portrait (9:16)
                    </label>
                  </li>
                </ul>
              </div>
            )}

            {isAIDiffclip && (
              <div>
                <h3 className="mb-6 text-2xl font-semibold">Quality:</h3>
                <ul className="flex flex-col gap-y-5">
                  <li className="flex items-center">
                    <input
                      type="radio"
                      value="low"
                      name="diffusionquality"
                      id="diffusionquality_low"
                      checked={state.diffusionQuality === 'low'}
                      onChange={handleChange}
                    />
                    <label
                      className="cursor-pointer ml-2 text-lg font-low"
                      htmlFor="diffusionquality_low"
                    >
                      Low
                    </label>
                  </li>
                  <li className="flex items-center">
                    <input
                      type="radio"
                      value="medium"
                      name="diffusionquality"
                      id="diffusionquality_medium"
                      checked={state.diffusionQuality === 'medium'}
                      onChange={handleChange}
                    />
                    <label
                      className="cursor-pointer ml-2 text-lg font-medium"
                      htmlFor="diffusionquality_medium"
                    >
                      Medium
                    </label>
                  </li>
                  <li className="flex items-center">
                    <input
                      type="radio"
                      value="high"
                      name="diffusionquality"
                      id="diffusionquality_high"
                      checked={state.diffusionQuality === 'high'}
                      onChange={handleChange}
                    />
                    <label
                      className="cursor-pointer ml-2 text-lg font-medium"
                      htmlFor="diffusionquality_high"
                    >
                      High
                    </label>
                  </li>
                  <li className="flex items-center">
                    <input
                      type="radio"
                      value="max"
                      name="diffusionquality"
                      id="diffusionquality_max"
                      checked={state.diffusionQuality === 'max'}
                      onChange={handleChange}
                    />
                    <label
                      className="cursor-pointer ml-2 text-lg font-medium"
                      htmlFor="diffusionquality_max"
                    >
                      Max
                    </label>
                  </li>
                </ul>
              </div>
            )}

            {isAIVqganclip && (
              <div>
                <label className="text-2xl font-semibold">Runtime:</label>
                <div className="mt-10 ml-3">
                  <Range
                    step={100}
                    min={100}
                    max={1500}
                    values={state.iterations}
                    onChange={handleSlider}
                    renderTrack={({ props, children }) => (
                      <div {...props} className="w-full h-[1px] pr-2 my-4 bg-mischka rounded-md">
                        {children}
                      </div>
                    )}
                    renderThumb={({ props }) => (
                      <div
                        className="w-5 h-5 transform translate-x-10 bg-gradient-to-r from-spindle to-spray rounded-full focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-white"
                        {...props}
                      >
                        <div className="absolute -top-7 right-[-3px] text-lg">
                          {state.iterations[0]}
                        </div>
                      </div>
                    )}
                  />
                </div>
              </div>
            )}
      </div>

	        {artworkImageUrl && (
        <div className="mt-16">
          <ImageDisplay
            imageUrl={artworkImageUrl}
            retryInterval={100}
            timeout={20000} // 20 seconds timeout
          />
        </div>
      )}

          <div className="mt-16 flex justify-center">
            <button
              className="mt-6 rounded-lg border-2 border-solid border-mischka bg-gradient-to-r from-spindle to-spray py-1 px-8 text-lg font-extrabold text-dark"
              type="button"
              onClick={handleBlend}
              disabled={isSubmitting}
            >
              blend now
              <Spinner loading={isSubmitting} />
            </button>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default CreateArt;
